import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { AuthenticationResult } from "@azure/msal-browser";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppConstants } from "../constants/constants";
@Injectable({
  providedIn: "root",
})
export class PublicNavGuard implements CanActivate {
  constructor(private router: Router, private authService: MsalService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    return this.authService.handleRedirectObservable().pipe(
      map((authResult: AuthenticationResult) => {
        if (authResult) {
          if(authResult.account !== null){
            this.router.navigate([AppConstants.DASHBOARD_PAGE]);
            return false;
          }
        }
        return true;
      })
    );
  }
}
